import React, { useContext, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { toast } from "react-hot-toast";
import PsContext from "../../../../context";
import axios from "axios";
import { ServiceUrl } from "../../../../utils/serviceUrl";
import { baseUrl } from "../../../../utils";

const ProfilePhotoUpload = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [newPhoto, setNewPhoto] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState("");

  const fileReaderChange = (e) => {
    try {
      const file = e.target.files[0];
      if (!file) return;

      const totalsize = file.size;
      const mz = props.minSize / 1000;
      const mx = props.maxSize / 1000;

      if (totalsize < props.minSize) {
        toast.error("File size must be greater than " + mz + " KB");
        setSelectedFileName(""); // clear filename
        return;
      }

      if (totalsize > props.maxSize) {
        toast.error("File size must be less than " + mx + " KB");
        setSelectedFileName(""); // clear filename
        return;
      }

      setSelectedFile(file);
      setSelectedFileName(file.name);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (readerEvent) => {
        setImagePreview(readerEvent.target.result);

        // ✅ Automatically upload after preview is ready
        setTimeout(() => {
          uploadFiles(file);
        }, 100);
      };
    } catch (err) {
      console.error(err);
    }
  };

  const getFile = () => {
    return imagePreview
      ? imagePreview
      : props.filePath
      ? baseUrl +
        ServiceUrl.UG.VIEW_CERTIFICATE +
        "?api_code=" +
        context.user.api_code +
        "&field_name=" +
        props.fileName
      : "";
  };

  const uploadFiles = (fileToUpload) => {
    setLoader(true);
    context.setLoader(true);

    const form = new FormData();
    form.append("i__apiCode", context.user.api_code);
    form.append("i__userId", context.user.user_id);
    form.append("i__userCode", context.user.user_code);
    form.append("i__fileName", props.fileName);
    form.append("i___file", fileToUpload || selectedFile);

    axios
      .post(ServiceUrl.UG.UPLOAD_FILE, form)
      .then((res) => {
        if (res.data.status === "1") {
          toast.success(res.data.message || "Success");
          setNewPhoto(false);
          setSelectedFile(null);
          setImagePreview(null);
          if (props.onSuccess) props.onSuccess();
        } else {
          toast.error(res.data.message || "Error");
        }
        context.setLoader(false);
      })
      .catch((err) => {
        toast.error("Upload failed");
        context.setLoader(false);
        console.error(err);
      });
  };

  return (
    <div>
      <Form
        action=""
        method="post"
        encType="multipart/form-data"
        id="frm_PhotoUpload"
      >
        <Row className="border-bottom py-3">
          <Col md={8}>
            <b>{props.title}</b>
            <div className="upload_info mt-2">{props.content}</div>
          </Col>
          <Col md={4}>
            <center>
              <img
                src={getFile()}
                alt="Profile Preview"
                style={{ width: "80px", cursor: "pointer" }}
              />
              <br />
              <input
                type="file"
                name="file"
                id={props.fileName}
                className="inputfile mt-2"
                onChange={(e) => {
                  fileReaderChange(e);
                }}
                accept=".png,.jpg,.jpeg"
              />
              <label htmlFor={props.fileName}>Choose a file</label>
              {selectedFileName && (
                <div className="mt-1 small text-muted">{selectedFileName}</div>
              )}
            </center>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ProfilePhotoUpload;
